// extracted by mini-css-extract-plugin
export var displayNone = "_tz-6";
export var imgContainer = "_tz-2";
export var overflowHidden = "_tz-3";
export var productInfoCardButtonContainer = "_tz-5";
export var productTitleText = "_tz-4";
export var rightArrow = "_tz-1";
export var rightArrowContainer = "_tz-0";